export default __webpack_public_path__ + "static/media/535.47220521.png";